export const CRM_CONNECTOR_CAPABILITIES = [
  {
    field: 'markRefundedSupported',
    operation: 'markRefunded',
    title: 'Mark transactions as refunded',
    description: 'Records a refund the issuer already made, without moving money.',
  },
  {
    field: 'orderTagsSupported',
    operation: 'orderTags',
    title: 'Tag orders',
    description: "Adds labels to an order so the client's team sees why Chargemont touched it.",
  },
  {
    field: 'recordChargebackSupported',
    operation: 'recordChargeback',
    title: 'Record chargebacks',
    description: "Writes each dispute into the CRM's own chargeback ledger.",
  },
] as const;

export type CrmConnectorCapabilityField = typeof CRM_CONNECTOR_CAPABILITIES[number]['field'];

export type CrmConnectorOperation = typeof CRM_CONNECTOR_CAPABILITIES[number]['operation'];

export type CrmConnectorDriverMetadataField = {
  key: string;
  label: string;
  type: 'integer' | 'string';
  required: boolean;
  requiredForLiveSubscriptionCancel: boolean;
  helperText: string;
};

export type CrmConnectorDriverOption = {
  value: string;
  label: string;
  baseUrl: { fixed: string } | { perTenant: true; helperText: string };
  hasSandbox: boolean;
  supportedOperations: readonly CrmConnectorOperation[];
  metadataFields: readonly CrmConnectorDriverMetadataField[];
};

// Mirrors CRM_CONNECTOR_DRIVER_DESCRIPTORS in apps/api/types/crmConnector.ts.
export const CRM_CONNECTOR_DRIVERS: readonly CrmConnectorDriverOption[] = [
  {
    value: 'vrio',
    label: 'Vrio',
    baseUrl: { fixed: 'https://api.vrio.app' },
    hasSandbox: false,
    supportedOperations: ['markRefunded', 'orderTags', 'recordChargeback'],
    metadataFields: [
      {
        key: 'subscriptionCancelReasonId',
        label: 'Subscription cancel reason ID',
        type: 'integer',
        required: false,
        requiredForLiveSubscriptionCancel: true,
        helperText: 'Vrio → Settings → Reporting Categories → Cancel Types',
      },
    ],
  },
];
export const CRM_CONNECTOR_NATIVE_LABEL = 'Standard CRM Connector API';

// Mirrors PAYMENT_CACHE_WINDOW_DAYS: the API's default when no window is set, and its cap.
export const CRM_MAX_CACHE_WINDOW_DAYS = 365;
export const CRM_CONNECTOR_PROXY_IP = '63.184.161.247';
